<template>
  <div class="template-info">
    <img class="header-background" v-if="bgImg" :src="bgImg" alt="background" />

    <div class="body-template">
      <div class="topic-wrapper">
        <back-button
          class="back-button-custom"
          caption="ย้อนกลับ"
          :clickButton="clickAction"
        />

        <div class="topic-title">
          <h2>{{ title }}</h2>
        </div>
      </div>

      <div class="contents-wrapper">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TemplateInfo",
  props: {
    bgImg: String,
    title: String,
    clickButton: {
      type: Function,
      default: function () {
        const hasHistory = window.history.length > 2;
        hasHistory ? this.$router.go(-1) : this.$router.push("/");
      },
    },
  },
  methods: {
    clickAction() {
      if (this.clickButton) {
        this.clickButton();
        return;
      }
    },
  },
};
</script>

<style scoped>
.template-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: calc(896px - 56px);
  flex: 1;
  max-width: 1440px;
}
.back-button-custom {
  margin-bottom: 16px;
  margin-top: 23px;
}
.header-background {
  width: 100%;

  min-height: 146px;
  max-height: 400px;
  object-fit: cover;
}

.body-template {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  max-width: 1120px;
  box-sizing: border-box;
}
.topic-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0px 30px;

  max-width: 1120px;
  box-sizing: border-box;
}

.topic-title {
  width: 100%;
  display: flex;
  border-bottom: 1px solid #acb1bf;
}
.topic-title h3 {
  white-space: break-spaces;
}
.contents-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 30px;
  padding-top: 23px;
  font-size: 17px;
  margin-bottom: 24px;
  color: #393d43;
}
.content-title {
  margin-bottom: 24px;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .back-button-custom {
    margin-top: 10px;
  }
  .header-background {
    min-height: 378.75px;
    max-height: fit-content;
  }
  .topic-wrapper {
    flex-direction: row;
    position: relative;
    margin-top: 20px;
    padding: 0px;
  }
  .bb-back {
    position: absolute;
  }
  .topic-title {
    justify-content: center;
    padding-bottom: 16px;
  }
  .topic-title h3 {
    white-space: normal;
  }
  .contents-wrapper {
    padding: 0px 0px;
    padding-top: 23px;
  }
  .body-template {
    padding: 0px 20px;
  }
  .template-info {
    margin: auto;
  }
}
</style>
